import { connect } from 'react-redux'

import { generateContactsWebAppConfig } from '@driftt/app-config'
import { showTransientNotification } from '@driftt/traffic-control'
import ContactDetails from 'components/ContactDetails'
import { receiveContact } from 'modules/contact_detail/actions'

const mapStateToProps = state => ({
  orgId: state.user.orgId,
  contact: state.__CRM.singleContact.contact,
  inboxID: state.embed?.configuration?.inboxId,
  linkedinIntegration: state.integrations?.status?.linkedin,
  appConfig: generateContactsWebAppConfig(state.user),
})

const mapDispatchToProps = dispatch => {
  return {
    onReceiveContact: contact => {
      dispatch(receiveContact(contact))
    },
    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactDetails)
